import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import reportWebVitals from './reportWebVitals';

// Override Crypto.subtle methods for HTTP (non-secure context)
if (typeof window !== "undefined" && !window.location.protocol.startsWith("https")) {
  const mockSubtle = {
    encrypt: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
    decrypt: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
    sign: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
    verify: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
    generateKey: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
    deriveKey: () => Promise.reject(new Error('Crypto.subtle is not available in insecure context')),
  };

  // Mock the subtle methods without replacing the entire object
  Object.keys(mockSubtle).forEach((method) => {
    if (window.crypto.subtle && typeof window.crypto.subtle[method] === 'function') {
      const originalMethod = window.crypto.subtle[method];
      window.crypto.subtle[method] = mockSubtle[method];
    }
  });
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure performance if needed
reportWebVitals();
